import { Landmark, Copy, CheckCircle2, XCircle } from "lucide-react";
import { SAHA_HESAPLARI } from "../data/mock";

export default function SahaHesaplari() {
  return (
    <div className="space-y-5" data-testid="page-saha-hesaplari">
      <div className="flex items-center gap-2.5">
        <div className="w-10 h-10 rounded-xl bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center">
          <Landmark className="text-[#F0651E]" size={22} />
        </div>
        <div>
          <h1 className="text-xl font-extrabold">Saha Hesapları</h1>
          <p className="text-xs text-slate-500">Bayilere tanımlı banka hesapları</p>
        </div>
      </div>

      <div className="bg-white dark:bg-[#151824] rounded-2xl shadow-sm border border-slate-100 dark:border-slate-800 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[13px] font-bold text-violet-600 dark:text-violet-400 border-b border-slate-100 dark:border-slate-800">
                <th className="px-6 py-3">BAYİ</th>
                <th className="px-4 py-3">MİN. YATIRIM</th>
                <th className="px-4 py-3">HESAP SAHİBİ</th>
                <th className="px-4 py-3">BANKA</th>
                <th className="px-4 py-3">IBAN</th>
                <th className="px-6 py-3">DURUM</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
              {SAHA_HESAPLARI.map((h, i) => (
                <tr key={i} className="hover:bg-slate-50 dark:hover:bg-slate-800/50" data-testid="hesap-row">
                  <td className="px-6 py-3 font-bold text-slate-700 dark:text-slate-200">{h.bayiId}</td>
                  <td className="px-4 py-3 text-slate-500">{h.minLabel}</td>
                  <td className="px-4 py-3">{h.hesapSahibi}</td>
                  <td className="px-4 py-3">{h.bank}</td>
                  <td className="px-4 py-3 font-mono text-xs text-slate-600 dark:text-slate-300">
                    <span className="inline-flex items-center gap-2">
                      {h.iban}
                      <button onClick={() => navigator.clipboard?.writeText(h.iban)} className="text-slate-400 hover:text-[#F0651E]"><Copy size={13} /></button>
                    </span>
                  </td>
                  <td className="px-6 py-3">
                    {h.aktif ? (
                      <span className="inline-flex items-center gap-1 text-green-600 font-semibold text-xs"><CheckCircle2 size={14} /> Aktif</span>
                    ) : (
                      <span className="inline-flex items-center gap-1 text-slate-400 font-semibold text-xs"><XCircle size={14} /> Pasif</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
